import { motion } from "framer-motion";
import { ScotiaPicker } from "./ScotiaPicker";
import { TrimCards } from "./TrimCards";

const Reveal = ({ children, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const AccessoriesSection = ({ colours }) => (
  <section className="relative bg-[#1C120A] text-white overflow-hidden" data-testid="accessories-section">
    <div
      className="pointer-events-none absolute inset-0 opacity-[0.05] mix-blend-overlay"
      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")" }}
    />

    <div className="max-w-7xl mx-auto px-6 py-20 md:py-24">
      <ScotiaPicker colours={colours} />
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-20 md:py-24">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#E8B57F]">02 — Trims</p>
            <h3 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight font-heading">Four trims, every edge covered</h3>
          </div>
          <p className="text-sm text-white/60 max-w-sm md:text-right">
            Aluminium and timber-look profiles sized for 7 mm hybrid boards. We will recommend the right one for each doorway and step when we measure up.
          </p>
        </Reveal>
        <TrimCards />
      </div>
    </div>
  </section>
);
